import { useSearchParams } from 'react-router-dom';

interface NewUrlProps {
  key: string;
  value: string;
}

export const useAddOrUpdateUrlParam = () => {
  const [searchParams] = useSearchParams();
  const newSearchParams = new URLSearchParams(searchParams);

  return {
    getNewUrl: ({ key, value }: NewUrlProps) => {
      newSearchParams.set(key, value);
      const hash = location.hash || '';
      return `${location.pathname}?${newSearchParams?.toString()}${hash}`;
    },
  };
};

export const useDeleteParamFromUrl = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const newSearchParams = new URLSearchParams(searchParams);

  return {
    deleteParam: (key: string) => {
      newSearchParams.delete(key);
      setSearchParams(newSearchParams);
    },
  };
};
